import { render, staticRenderFns } from "./DadataAddressResolver.vue?vue&type=template&id=7317a813&"
import script from "./DadataAddressResolver.vue?vue&type=script&lang=js&"
export * from "./DadataAddressResolver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports